import InfluencerIdentityRow, { IInfluencerIdentityRowProps as IRowProps } from './Row'
import { InfluencerIdentityRowRoot } from './Row.styled'

export type IInfluencerIdentityRowProps = IRowProps
export { InfluencerIdentityRowRoot }
export default InfluencerIdentityRow
